import type { Filter } from "../types";
import { getBaseApi } from "../api";

const api = getBaseApi();

export const getMapCategories = async (workspaceId: string, filter: Filter | boolean = false) => {
  const response = await api.get(`/map/categories/workspaces/${workspaceId}`, { params: filter ? filter : undefined });
  return response.data;
};

export const getMapCategory = async (categoryId: string) => {
  const response = await api.get(`/map/categories/${categoryId}`);
  return response.data?.data;
};

export const createCategory = async (data: {workspace: string, name: string, tags: string[]}) => {
  const response = await api.post(`/map/categories`, data);
  return response.data?.data;
};

export const createBulkCategory = async (data: {workspace: string, categories: { name: string, tags: string[] }[]}) => {
  const response = await api.post(`/map/categories/bulk`, data);
  return response.data?.data;
};

export const updateCategory = async (categoryId: string, data: { name: string, tags: string[]}) => {
  const response = await api.put(`/map/categories/${categoryId}`, data);
  return response.data?.data;
};

export const deleteCategory = async (categoryId: string) => {
  const response = await api.delete(`/map/categories/${categoryId}`);
  return response.data?.data;
};

export const getOrganisationMapData = async (workspaceId: string, organisationId: string) => {
  const response = await api.get(`/map/data/workspaces/${workspaceId}?organisation=${organisationId}`);
  return response.data?.data;
};

export const updateMapData = async (data: {
  category: string;
  organisation: string;
  tags: string[];
}[]) => {
  const response = await api.put(`/map/data/multiple`, { data: data });
  return response.data?.data;
};

export const getCategoryMapData = async (categoryId: string) => {
  const response = await api.get(`/map/categories/${categoryId}/data`);
  return response.data?.data;
};